class FilterManager {
  constructor() {
    console.log('FilterManager initialized');
    this.sidebar = window.sidebar;
    this.filterForm = document.getElementById('filter-form');
    console.log('filterForm:', this.filterForm);

    if (!this.filterForm) {
      console.log('No filter form found - returning early');
      return;
    }

    // Store current URL for filter state
    this.currentUrl = window.location.pathname + window.location.search;

    this.bindEvents();
  }

  bindEvents() {
    console.log('bindEvents start');

    // Handle form submission
    this.filterForm.addEventListener('submit', (e) => {
      console.log('form submit');
      e.preventDefault();
      this.applyFilters();
    });

    // Handle individual input changes
    this.filterForm.querySelectorAll('input').forEach((input) => {
      console.log('Adding listener to input:', input);
      input.addEventListener('change', async (e) => {
        console.log('input change');
        e.preventDefault();

        // First apply the filters to update the products
        await this.applyFilters();

        // Then explicitly fetch and update the sidebar template
        const template = document.body.dataset.template;
        const mainSectionId = template === 'search' ? 'main-search' : 'main-collection';
        const url = window.location.pathname + window.location.search;

        const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}sections=aside-sidebar`);
        const sections = await response.json();

        if (sections['aside-sidebar']) {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(sections['aside-sidebar'], 'text/html');
          const filtersTemplate = parsedContent.getElementById('sidebar-collection-filters-template');

          if (filtersTemplate) {
            // Update the template
            const existingTemplate = document.getElementById('sidebar-collection-filters-template');
            if (existingTemplate) {
              existingTemplate.innerHTML = filtersTemplate.innerHTML;
            }

            // Update the active sidebar content if filters are open
            const sidebarContent = document.getElementById('sidebar-content');
            if (sidebarContent && this.sidebar.currentType === 'collection-filters') {
              sidebarContent.innerHTML = filtersTemplate.innerHTML;
              // Instead of creating a new FilterManager, rebind events to the new form
              this.filterForm = document.getElementById('filter-form');
              this.bindEvents();
            }
          }
        }
      });
    });

    // Handle clear all filters link
    const clearAllLink = this.filterForm.querySelector('a[href*="collection.url"]');
    if (clearAllLink) {
      clearAllLink.addEventListener('click', (e) => {
        console.log('clear all clicked');
        e.preventDefault();
        const baseUrl = clearAllLink.getAttribute('href');
        this.fetchSection(baseUrl);
        window.history.pushState({ path: baseUrl }, '', baseUrl);
      });
    }

    console.log('bindEvents complete');
  }

  applyFilters() {
    console.log('applyFilters');
    // Get form data and construct URL
    const formData = new FormData(this.filterForm);
    const searchParams = new URLSearchParams(formData);

    // Preserve existing search query if it exists
    const currentParams = new URLSearchParams(window.location.search);
    const searchQuery = currentParams.get('q');
    if (searchQuery) {
      searchParams.set('q', searchQuery);
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    this.currentUrl = newUrl;

    // Update browser history without page reload
    window.history.pushState({ path: newUrl }, '', newUrl);

    // Fetch updated section
    this.fetchSection(newUrl);
  }

  // Add method to refresh filters with current URL
  refreshFilters() {
    console.log('refreshFilters with URL:', this.currentUrl);
    this.fetchSection(this.currentUrl || window.location.pathname + window.location.search);
  }

  async fetchSection(url) {
    try {
      const template = document.body.dataset.template;
      const mainSectionId = template === 'search' ? 'main-search' : 'main-collection';

      // Add loading states
      const mainContent = document.querySelector(`.section--${mainSectionId}`);
      const sidebarContent = document.getElementById('sidebar-content');

      if (mainContent) mainContent.classList.add('render--loading');
      if (sidebarContent) sidebarContent.classList.add('render--loading');

      // Fix URL construction - check if URL already has parameters
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}sections=${mainSectionId},aside-sidebar`);
      const sections = await response.json();

      // Remove loading states
      if (mainContent) mainContent.classList.remove('render--loading');
      if (sidebarContent) sidebarContent.classList.remove('render--loading');

      // Update the main content section
      if (mainContent && sections[mainSectionId]) {
        const parser = new DOMParser();
        const parsedContent = parser.parseFromString(sections[mainSectionId], 'text/html');
        const newContent = parsedContent.querySelector(`.section--${mainSectionId}`);
        if (newContent) {
          mainContent.innerHTML = newContent.innerHTML;
          window.sidebar = new Sidebar();
          // Reinitialize QuickAddManager for the new product cards
          new QuickAddManager();

          const event = new CustomEvent('shopify:section:load', {
            detail: { sectionId: mainSectionId },
            bubbles: true,
          });
          mainContent.dispatchEvent(event);
        }
      }

      // Update the sidebar template first
      if (sections['aside-sidebar']) {
        const parser = new DOMParser();
        const parsedContent = parser.parseFromString(sections['aside-sidebar'], 'text/html');
        const filtersTemplate = parsedContent.getElementById('sidebar-collection-filters-template');

        if (filtersTemplate) {
          // Update the template first
          const existingTemplate = document.getElementById('sidebar-collection-filters-template');
          if (existingTemplate) {
            existingTemplate.innerHTML = filtersTemplate.innerHTML;
          }

          // Then update the active sidebar content if filters are open
          const sidebarContent = document.getElementById('sidebar-content');
          if (sidebarContent && this.sidebar.currentType === 'collection-filters') {
            // Keep the current form and just update its inputs
            const newForm = filtersTemplate.querySelector('#filter-form');
            if (newForm && this.filterForm) {
              // Update checkboxes and other inputs
              const newInputs = newForm.querySelectorAll('input');
              const currentInputs = this.filterForm.querySelectorAll('input');

              currentInputs.forEach((input, index) => {
                const newInput = newInputs[index];
                if (newInput) {
                  input.checked = newInput.checked;
                  input.disabled = newInput.disabled;
                }
              });
            }
          }
        }
      }
    } catch (error) {
      console.error('Error updating filters:', error);
      // Remove loading states on error
      const mainContent = document.querySelector(`.section--${mainSectionId}`);
      const sidebarContent = document.getElementById('sidebar-content');

      if (mainContent) mainContent.classList.remove('render--loading');
      if (sidebarContent) sidebarContent.classList.remove('render--loading');
    }
  }
}

// Instead of DOMContentLoaded, listen for sidebar content load
document.addEventListener('sidebar:collection-filters-loaded', (event) => {
  console.log('Filters loaded');
  const template = document.body.dataset.template;
  if (template === 'collection' || template === 'search') {
    console.log('Initializing FilterManager');
    const filterManager = new FilterManager();
    // Refresh filters when sidebar is opened
    filterManager.refreshFilters();
  }
});
